import {NgModule} from '@angular/core';
import {RouteReuseStrategy, RouterModule, Routes} from '@angular/router';
import {ErrorComponent} from "./error/error.component";
import {gamePlayCanMatch} from "./game-play/can-match-route";
import {HomeComponent} from "./components/home/home.component";
import {GamePlayEditComponent} from "./components/game-play-edit/game-play-edit.component";
import {ResumeGameComponent} from "./game-play/resume-game/resume-game.component";
import {SelectPlayOptionsComponent} from "./game-play/select-play-options/select-play-options.component";
import {AuthentificatedComponent} from "./components/layout/authentificated/authentificated.component";
import {AuthGuard} from "./guard/auth.guard";
import {UnauthenticatedComponent} from "./components/layout/unauthenticated/unauthenticated.component";
import {AuthComponent} from "./components/auth/auth.component";
import {ForgotPasswordComponent} from "./components/forgot-password/forgot-password.component";
import {
  SelectPlayOptionOvertimeComponent
} from "./game-play/select-play-option-overtime/select-play-option-overtime.component";
import { ConfigurableRouteReuseStrategy } from './route-strategy/configurable-route-reuse-strategy';
import PlayListComponent from "./components/play-list/play-list.component";
import {PlayListEditComponent} from "./components/play-list-edit/play-list-edit.component";
import { GamePlayListComponent } from './components/game-play-list/game-play-list.component';

const routes: Routes = [
  {
    path: '',
    component: AuthentificatedComponent, // Layout for authenticated routes
    canActivate: [AuthGuard], // AuthGuard to protect these routes
    children: [
      { path: '', component: HomeComponent, pathMatch: 'full' },
      {
        path: 'game-play',
        loadChildren: () =>
          import('./game-play/game-play.module').then(m => m.GamePlayModule),
        canMatch: [gamePlayCanMatch],
        canActivate: [AuthGuard]
      },
      { path: 'v1-game-play-list', component: GamePlayListComponent },
      { path: 'v1-game-play-list/:id', component: GamePlayEditComponent },
      { path: 'game-play-list', component: PlayListComponent },
      { path: 'game-play-list/:id', component: PlayListEditComponent },
      { path: 'resume-game-play', component: ResumeGameComponent },
      { path: 'select-play-options-overtime', component: SelectPlayOptionOvertimeComponent },
      { path: 'select-play-options', component: SelectPlayOptionsComponent },
    ]
  },
  {
    path: '',
    component: UnauthenticatedComponent,  // Layout for non-authenticated routes
    children: [
      { path: 'login', component: AuthComponent },
      { path: 'forget-password', component: ForgotPasswordComponent },
    ]
  },

  { path: '**', component: ErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [
    { provide: RouteReuseStrategy, useClass: ConfigurableRouteReuseStrategy }
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
